module.exports = __webpack_public_path__ + "static/media/ruler.5c31419d.svg";